import React, { useState } from 'react';
import './meetpros.css';


// Data for project stages
const stages = [
  {
    title: "Planning & Design",
    definition: "Consultants engaged to compile the required drawings and specifications for the project to be approved by the local authority",
  },
  {
    title: "Pre-Commencement",
    definition: "Consultants engaged to compile documents ready for procurement & construction.",
  },
  {
    title: "Procurement",
    definition: "Tendering process for engaging the contractor to carry out the building works of the project",
  },
  {
    title: "Construction",
    definition: "Building phase of the project",
  },
  {
    title: "Post Construction",
    definition: "Final phase of the project involving final inspections, handover, fixing defects, landscaping, and final clean",
  }
];

// Data for professional definitions
const professionals = [
  { type: "Architect", definition: "Qualified & Registered to produce schematic designs and specifications for the project.", stage: "Planning & Design" },
  { type: "Draftsman", definition: "Produces schematics and specifications and assists architects.", stage: "Planning & Design" },
  { type: "Castral or Land Surveyor", definition: "Measures and determines property boundaries, site contours, sets out building footprint, provides level guide for builder, and confirms floor and roof levels as per approved drawings.", stage: "Planning & Design" },
  { type: "Stormwater Engineer", definition: "Designs systems to prevent flooding, manage stormwater runoff, and integrate with local infrastructure.", stage: "Planning & Design" },
  { type: "Sustainability Consultant", definition: "Ensures environmental and sustainability standards are met and assists in energy-efficient design.", stage: "Planning & Design" },
  { type: "Landscape Architect", definition: "Produces designs and specifications for outdoor landscaping, including soft and hardscape elements.", stage: "Planning & Design" },
  { type: "Arborist Consultant", definition: "Advises on tree health, management, or removal during construction.", stage: "Planning & Design" },
  { type: "Bushfire Consultant", definition: "Assesses bushfire risk and provides construction methodology to mitigate hazards.", stage: "Planning & Design" },
  { type: "Asbestos & Hazardous Materials Consultant", definition: "Identifies asbestos and hazardous materials and recommends safe removal methods.", stage: "Planning & Design" },
  { type: "Heritage Consultant", definition: "Advises on conservation of heritage buildings, landscapes, and cultural sites.", stage: "Planning & Design" },
  { type: "Geotechnical Engineer", definition: "Assesses below-ground conditions and advises on foundation systems.", stage: "Planning & Design" },
  { type: "Structural Engineer", definition: "Designs and advises on building structural elements including shoring, foundations, floors, walls, ceilings, and roof support systems.", stage: "Planning & Design" },
  { type: "Services Engineer", definition: "Designs building services such as plumbing, electrical, mechanical, fire protection, and transportation systems.", stage: "Planning & Design" },
  { type: "Civil Engineer", definition: "Designs external infrastructure requirements including stormwater systems, driveways, kerbs, footpaths, and roadworks.", stage: "Planning & Design" },
  { type: "Quantity Surveyor", definition: "Provides project estimates, cost monitoring, and tax depreciation schedules.", stage: "Planning & Design" },
  { type: "Interior Designer", definition: "Designs interior decorations for rooms and buildings.", stage: "Planning & Design" },
  { type: "Private Certifier / Building Surveyor", definition: "Assesses and approves projects according to relevant state regulations.", stage: "Planning & Design" },
  { type: "Thermal Performance Assessor", definition: "Evaluates building energy efficiency and temperature maintenance.", stage: "Planning & Design" },
  { type: "Real Estate Agents", definition: "Qualified to sell or rent buildings or land.", stage: "Planning & Design" },
  { type: "Buyers Agents", definition: "Acts on behalf of buyers to search, evaluate, negotiate, and bid for property purchases.", stage: "Planning & Design" },
  { type: "Conveyancers", definition: "Handles the legal aspects of buying and selling property.", stage: "Planning & Design" },
  { type: "Estimator", definition: "Provides estimates and cost monitoring of projects.", stage: "Pre-Commencement" },
  { type: "Finance Brokers", definition: "Negotiates between clients and lenders for home, investment, or construction loans.", stage: "Procurement" },
  { type: "Building Contractor", definition: "Licensed to perform building works for a project.", stage: "Procurement" },
  { type: "Site Establishment Contractors", definition: "Helps set up the site with safety fencing, toilets, and waste removal services.", stage: "Construction" },
  { type: "Subcontractor", definition: "Specializes in supplying materials and labor for specific trades.", stage: "Construction" },
  { type: "Supplier", definition: "Provides materials for specific trades.", stage: "Construction" },
  { type: "Demolition Contractor", definition: "Handles demolition and removal of existing building materials, including hazardous materials.", stage: "Construction" },
  { type: "Excavation Contractor", definition: "Clears vegetation and performs excavation works for the project.", stage: "Construction" },
  { type: "Concreter", definition: "Forms, mixes, pours, and finishes concrete for the project.", stage: "Construction" },
  { type: "Masoner or Bricklayer", definition: "Provides labor and lays masonry for the project.", stage: "Construction" },
  { type: "Carpenter", definition: "Installs framing, cladding, doors, windows, and various timber structures.", stage: "Construction" },
  { type: "Structural Steel Fabricator & Installer", definition: "Produces and installs structural steel elements like beams, columns, and framing.", stage: "Construction" },
  { type: "Glaziers", definition: "Supplies and installs windows, doors, shower screens, balustrades, and privacy screens.", stage: "Construction" },
  { type: "Waterproofing Contractor", definition: "Applies protective treatments in wet areas, balconies, roofs, and retaining walls.", stage: "Construction" },
  { type: "Tiler or Tiling Contractor", definition: "Installs floor and wall tiles in various materials.", stage: "Construction" },
  { type: "Plasterer or Gyprocker", definition: "Installs plasterboard wall and ceiling linings and insulation.", stage: "Construction" },
  { type: "Renderers", definition: "Applies render and special plaster finishes to buildings or hard surfaces.", stage: "Construction" },
  { type: "Metal Works Contractors", definition: "Supplies and installs metal works for projects, including balustrades, pergolas, and metal cladding.", stage: "Construction" },
  { type: "Joiners", definition: "Supplies and installs functional items like glazing, kitchen joinery, wardrobes, and vanities.", stage: "Construction" },
  { type: "Fixtures & Fittings Suppliers", definition: "Provides appliances, tapware, and sanitary ware.", stage: "Construction" },
  { type: "Electrician", definition: "Installs power, lighting, and communication systems.", stage: "Construction" },
  { type: "Plumber", definition: "Installs water, sewer, stormwater, and gas services.", stage: "Construction" },
  { type: "Air Conditioning or Mechanical Contractor", definition: "Installs air-conditioning and exhaust systems.", stage: "Construction" },
  { type: "Fire Services Contractor", definition: "Installs fire safety systems, including smoke alarms and sprinklers.", stage: "Construction" },
  { type: "Transportation Contractors", definition: "Installs transportation systems such as lifts, car stackers, and wheelchair lifts.", stage: "Construction" },
  { type: "Cleaners", definition: "Provides interim or final cleaning of all surfaces of a project.", stage: "Post Construction" },
  { type: "Soft Landscapers", definition: "Supplies and maintains living elements of outdoor spaces like grass, plants, and trees.", stage: "Post Construction" },
  { type: "Hardscape Contractors", definition: "Handles hard surfaces of outdoor spaces, including paving and retaining walls.", stage: "Post Construction" },
  { type: "Fencing Supplier & Installer", definition: "Supplies and installs fencing, screens, and gates.", stage: "Post Construction" },
  { type: "Swimming Pool Contractors", definition: "Supplies and installs swimming pools and spas.", stage: "Post Construction" }
];
const MeetThePros = () => {
  const [selectedStage, setSelectedStage] = useState(null);
  const [selectedProfessional, setSelectedProfessional] = useState(null);

  // Filter professionals by selected stage
  const professionalsByStage = professionals.filter(
    (prof) => prof.stage === selectedStage?.title
  );

  return (
    <div className="containermeet">



      {/* Left Column - Project Stages and Professionals List */}
      <div className="left-column">
        <header className="header">

        <section class="connect-with-clients blue_bg_section" style={{paddingTop: 20}}>
            <div class="container">
              <div class="row">
                <div class="col-sm-12">
                  <h2>Meet the Professionals</h2>
                </div>
              </div>
            </div>
          </section>

        </header>



        {/* Project Stages */}
        <section>
          <h2>Explore the stages of a building project and learn about the professionals who bring it to life.</h2>
          <div className="stages-list">
            {stages.map((stage) => (
              <div key={stage.title} className="stage">
                <div
                  className={`stage-item ${selectedStage?.title === stage.title ? 'active' : ''}`}
                  onClick={() =>
                    setSelectedStage(
                      selectedStage?.title === stage.title ? null : stage
                    )
                  }
                >
                  <h3>{stage.title}</h3>
                  {selectedStage?.title === stage.title && (
                    <p>{stage.definition}</p>
                  )}
                </div>
                {selectedStage?.title === stage.title && (
                  <div className="professionals-list">
                    {professionalsByStage.map((prof) => (
                      <div
                        key={prof.type}
                        className={`professional-item ${
                          selectedProfessional?.type === prof.type ? 'active' : ''
                        }`}
                        onClick={() =>
                          setSelectedProfessional(
                            selectedProfessional?.type === prof.type ? null : prof
                          )
                        }
                      >
                        <h4>{prof.type}</h4>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* Right Column - Professional Details */}
      <div className="right-column">
        {selectedProfessional ? (
          <section className="professional-details">
            <h2>{selectedProfessional.type}</h2>
            <p>
              <strong>Stage:</strong> {selectedProfessional.stage}
            </p>
            <div className="image-placeholder">
              <span>Image Placeholder</span>
            </div>
            <p>{selectedProfessional.definition}</p>
          </section>
        ) : (
          <div className="placeholder-text">
            Select a professional to see details
          </div>
        )}
      </div>
    </div>
  );
};


export default MeetThePros;
